import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router, preloadLazyRoutes } from './router.tsx';
import { startOutboxRetries } from './lib/backgroundSave.ts';
import { initDiag } from './lib/diag.ts';
import { sfx } from './lib/sfx.ts';
import './styles.css';

initDiag();
// Sessions whose save never got through (offline, a closed tab) are retried from here.
startOutboxRetries();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// Warm every lazy route chunk once the first paint is out of the way, so a tap on a stop
// (which navigates via nav(), bypassing router-level intent preloading) never waits on one.
// Also build the AudioContext here: the first `new AudioContext()` on a page costs ~180ms, and
// without this it happens synchronously inside that same tap, via audio.unlock() -> sfx.unlock().
const ric =
  typeof requestIdleCallback === 'function'
    ? requestIdleCallback
    : (cb: () => void) => setTimeout(cb, 1500);
ric(() => {
  preloadLazyRoutes();
  sfx.warm();
});
